import React, { useState } from "react";
import { Calendar as CalendarIcon, ChevronDown } from "lucide-react";

import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Período dentro da própria barra de filtros, em vez de ocupar uma faixa
// inteira embaixo. O gatilho já diz qual período está valendo.
const PRESETS = [
  { key: "hoje", label: "Hoje" },
  { key: "ontem", label: "Ontem" },
  { key: "7dias", label: "Últimos 7 dias" },
  { key: "mes", label: "Este mês" },
];

const soData = (iso) => {
  if (!iso) return "";
  const [a, m, d] = String(iso).split("-");
  return d ? `${d}/${m}` : iso;
};

export default function FiltroPeriodo({
  presetAtivo, dataDe, dataAte, horaDe, horaAte, dataMaisAntiga,
  onPreset, onLimpar, onAplicarPersonalizado,
}) {
  const [aberto, setAberto] = useState(false);
  const [de, setDe] = useState(dataDe || "");
  const [ate, setAte] = useState(dataAte || "");
  const [hDe, setHDe] = useState(horaDe || "");
  const [hAte, setHAte] = useState(horaAte || "");

  const hoje = new Date();
  const hojeStr = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, "0")}-${String(hoje.getDate()).padStart(2, "0")}`;
  const ativo = !!(dataDe || dataAte);
  const rotulo = ativo
    ? (PRESETS.find((p) => p.key === presetAtivo)?.label
       || `${soData(dataDe) || "…"} a ${soData(dataAte) || "…"}`)
    : "Período";

  return (
    <Popover open={aberto} onOpenChange={(v) => {
      setAberto(v);
      if (v) { setDe(dataDe || ""); setAte(dataAte || ""); setHDe(horaDe || ""); setHAte(horaAte || ""); }
    }}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-e2e="filtro-periodo"
          className={`h-9 px-2.5 rounded-lg border text-sm flex items-center gap-1.5 transition-colors ${
            ativo
              ? "border-primary/50 bg-primary/5 text-foreground font-medium"
              : "border-border bg-background text-muted-foreground hover:bg-muted hover:text-foreground"
          }`}
        >
          <CalendarIcon className="w-3.5 h-3.5 shrink-0" />
          <span className="truncate max-w-[140px]">{rotulo}</span>
          <ChevronDown className="w-3.5 h-3.5 shrink-0 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0" align="start">
        <div className="py-1">
          {PRESETS.map(({ key, label }) => (
            <button
              key={key}
              type="button"
              data-e2e={`periodo-${key}`}
              onClick={() => { onPreset(key); setAberto(false); }}
              className={`w-full px-3 py-2 text-left text-sm hover:bg-muted transition-colors ${
                presetAtivo === key ? "text-primary font-semibold" : ""
              }`}
            >
              {label}
            </button>
          ))}
        </div>
        <div className="border-t p-3 space-y-2">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
            Período personalizado
          </p>
          <div className="grid grid-cols-[1fr_auto] gap-2">
            <input type="date" value={de} min={dataMaisAntiga || undefined} max={hojeStr}
              onChange={(e) => setDe(e.target.value)}
              className="h-9 px-2 rounded-md border bg-background text-sm" />
            <input type="time" value={hDe} onChange={(e) => setHDe(e.target.value)}
              className="h-9 px-2 rounded-md border bg-background text-sm w-24" />
          </div>
          <div className="grid grid-cols-[1fr_auto] gap-2">
            <input type="date" value={ate} min={de || dataMaisAntiga || undefined} max={hojeStr}
              onChange={(e) => setAte(e.target.value)}
              className="h-9 px-2 rounded-md border bg-background text-sm" />
            <input type="time" value={hAte} onChange={(e) => setHAte(e.target.value)}
              className="h-9 px-2 rounded-md border bg-background text-sm w-24" />
          </div>
          <button
            type="button"
            data-e2e="periodo-aplicar"
            disabled={!de && !ate}
            onClick={() => { onAplicarPersonalizado({ de, ate, hDe, hAte }); setAberto(false); }}
            className="w-full h-9 rounded-md bg-primary text-primary-foreground text-sm font-bold disabled:opacity-50"
          >
            Aplicar
          </button>
        </div>
        {ativo ? (
          <button
            type="button"
            onClick={() => { onLimpar(); setAberto(false); }}
            className="w-full border-t py-2 text-xs text-muted-foreground hover:text-destructive transition-colors"
          >
            Limpar período
          </button>
        ) : null}
      </PopoverContent>
    </Popover>
  );
}
